var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-full flex justify-center items-center"},[_c('LogoSquareIcon',{staticClass:"mx-auto h-[45px] animate-[spin_5s_linear_infinite] duration-1000 ease-linear",attrs:{"fill-class":"fill-[#0c5c51]"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }